import PostViewer from 'post/PostViewer';

export const PostPage = () => {
  return (
    <div className="PostPage">
      <PostViewer />
    </div>
  );
};